/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CategoryBasicView } from './categoryBasicView';
import { LocationObject } from './locationObject';
import { OrganizationLink } from './organizationLink';
import { ProjectBasic } from './projectBasic';
import { ProjectCommunity } from './projectCommunity';
import { ProjectPermissions } from './projectPermissions';
import { UserBasic } from './userBasic';
import { UserRelationToGroup } from './userRelationToGroup';
import { ValidityPeriod } from './validityPeriod';

export interface Project extends ProjectBasic { 
    permissions: ProjectPermissions;
    description: string;
    website?: string;
    diseases: Array<CategoryBasicView>;
    funding_source?: string;
    linked_organizations: Array<OrganizationLink>;
    community?: ProjectCommunity;
    linked_projects?: Array<ProjectBasic>;
}